.card {
  background-color: var(--journey-card-bg);
  border: 1px solid rgba(15, 43, 60, 0.08);
  border-radius: 22px;
  box-shadow: var(--shadow-close);
  box-sizing: border-box;
  color: var(--journey-card-fg);
  display: flex;
  flex-direction: column;
  font-family: var(--font-family-base);
  font-size: 16px;
  gap: 22px;
  overflow: hidden;
  padding: 22px 18px 16px;
  position: relative;
  width: 100%;
}

/* Behind the content, partly outside the top right corner. */
.dots {
  pointer-events: none;
  position: absolute;
  right: -18px;
  top: -18px;
}

.card > :not(.dots) {
  position: relative;
  z-index: 1;
}

.identity {
  align-items: center;
  display: flex;
  gap: 14px;
  min-width: 0;
}

/* The profile picture with a thin amber ring segment, open at the top left, as on the desktop card. */
.portrait {
  display: flex;
  flex: none;
  padding: 6px;
  position: relative;
}

.photo {
  display: block;
  height: 64px;
  width: 64px;
}

.ring {
  inset: 0;
  position: absolute;
  transform: rotate(-90deg);
}

.ring circle {
  stroke: var(--color-accent);
}

.titles {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.name,
.title {
  font-family: var(--font-family-heading);
  font-weight: 700;
  line-height: 1.15;
  margin: 0;
  overflow-wrap: anywhere;
}

.name {
  font-size: 24px;
}

.title {
  font-size: 16px;
  font-weight: 400;
}

.muted {
  align-items: center;
  display: flex;
  font-size: 13px;
  gap: 8px;
  margin: 4px 0 0;
  min-width: 0;
  opacity: 0.7;
}

.muted span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* The total and the four categories, centred as one group with a fixed gap. */
.scores {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  justify-content: center;
}

/* EmScore draws its numbers and labels in the text tokens, which are dark. On a dark card they take the card's colour. */
.dark .scores {
  --color-text: var(--journey-card-fg);
  --color-text-muted: var(--journey-card-fg);
}

.questions {
  display: grid;
  gap: 8px 10px;
  grid-template-columns: repeat(2, auto);
}

.pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  list-style: none;
  margin: 0;
  padding: 0;
}

.pill {
  align-items: center;
  background: var(--color-surface);
  border: 1px solid rgba(15, 43, 60, 0.12);
  border-radius: 15px;
  color: var(--color-primary);
  display: flex;
  font-size: 13px;
  gap: 6px;
  line-height: 1;
  padding: 8px 12px;
  white-space: nowrap;
}

.footer {
  align-items: center;
  border-top: 1px solid color-mix(in srgb, var(--journey-card-fg) 15%, transparent);
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding-top: 14px;
}

/* 48 px with the quiet zone, so it scans on any card colour. */
.qrCode {
  flex: none;
  line-height: 0;
  padding: 2px;
}

.verified {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  font-size: 12px;
  line-height: 1.3;
  white-space: nowrap;
}

.caption {
  color: var(--journey-card-caption);
  font-weight: 600;
}

/* Wraps under the QR code on the narrowest screens, still to the right. */
.logo {
  display: flex;
  flex: none;
  margin-left: auto;
}

